import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const routeLabels = {
  '/subscription/book-of-the-month': 'subscription.bookOfTheMonth.title',
  '/subscription/personal': 'subscription.personal.title',
  '/subscriptions/thematic': 'nav.thematicSubscriptions',
  '/gifts': 'gifts.title',
  '/company': 'nav.companyOffer',
  '/cart': 'nav.basket',
  '/checkout': 'checkout.title',
  '/moja-biblioteka': 'nav.myLibrary',
  '/moja-biblioteka/historia': 'customer.history',
  '/moja-biblioteka/subskrypcje': 'customer.subscriptions',
  '/moja-biblioteka/ksiegarz': 'customer.myBookseller',
  '/moja-biblioteka/profil': 'library.profile.title',
}

export default function Breadcrumbs() {
  const { t } = useTranslation()
  const location = useLocation()

  if (location.pathname === '/') return null

  const labelKey = routeLabels[location.pathname]

  return (
    <nav
      aria-label={t('breadcrumb.label', { defaultValue: 'Breadcrumb' })}
      className="max-w-6xl mx-auto px-4 pt-24 pb-2"
    >
      <ol className="flex items-center gap-2 text-sm text-brand-blue/80">
        <li>
          <Link to="/" className="hover:text-brand-orange transition font-bold">
            {t('nav.home')}
          </Link>
        </li>
        {labelKey && (
          <>
            <li aria-hidden="true">/</li>
            <li className="font-bold">{t(labelKey)}</li>
          </>
        )}
      </ol>
    </nav>
  )
}
